import { useState } from 'react';

import { analytics } from 'analytics';
import { GlobalModalsContext } from 'contexts/globalModalsContext';

import AuthenticationModal from './AuthenticationModal';
import BrowseTemplatesModal from './BrowseTemplatesModal';
import ConversionModal from './ConversionModal';
import OpenDiagramModal from './OpenDiagramModal';
import SmartImportModal from './SmartImportModal';

type Props = {
  children: React.ReactNode;
};

const GlobalModalsProvider: React.FC<Props> = ({ children }) => {
  const [isSignUpModalOpen, setSignUpModalOpen] = useState(false);
  const [isSignInModalOpen, setSignInModalOpen] = useState(false);
  const [isConversionModalOpen, setConversionModalOpen] = useState(false);
  const [isSmartImportModalOpen, setSmartImportModalOpen] = useState(false);
  const [isOpenDiagramModalOpen, setOpenDiagramModalOpen] = useState(false);
  const [isBrowseTemplatesModalOpen, setBrowseTemplatesModalOpen] =
    useState(false);

  const [lastTriggerAction, setLastTriggerAction] = useState('Saving');

  return (
    <GlobalModalsContext.Provider
      value={{
        isAuthOrConversionModalOpen:
          isSignUpModalOpen || isSignInModalOpen || isConversionModalOpen,
        openSignUpModal: () => {
          analytics.track('Sign Up Modal - Open');
          setSignUpModalOpen(true);
        },
        openSignInModal: () => {
          analytics.track('Sign In Modal - Open');
          setSignInModalOpen(true);
        },
        openConversionModal: (triggerAction: string) => {
          analytics.track('Conversion Modal - Open', { triggerAction });
          setLastTriggerAction(triggerAction);
          setConversionModalOpen(true);
        },
        openSmartImportModal: () => {
          analytics.track('Smart Import Dialog - Open');
          setSmartImportModalOpen(true);
        },
        openOpenDiagramModal: () => {
          analytics.track('Open Diagram Modal - Open');
          setOpenDiagramModalOpen(true);
        },
        openBrowseTemplatesModal: () => {
          analytics.track('Browse Templates Modal - Open');
          setBrowseTemplatesModalOpen(true);
        },
      }}
    >
      {children}
      <AuthenticationModal
        open={isSignUpModalOpen}
        setOpen={setSignUpModalOpen}
        title="Sign up to SankeyArt"
        analyticsName="Sign Up Modal"
        defaultAction="sign-up"
      />
      <AuthenticationModal
        open={isSignInModalOpen}
        setOpen={setSignInModalOpen}
        title="Sign in to SankeyArt"
        analyticsName="Sign In Modal"
        defaultAction="sign-in"
      />
      <ConversionModal
        open={isConversionModalOpen}
        setOpen={setConversionModalOpen}
        triggerAction={lastTriggerAction}
      />
      <SmartImportModal
        open={isSmartImportModalOpen}
        setOpen={setSmartImportModalOpen}
      />
      <OpenDiagramModal
        open={isOpenDiagramModalOpen}
        setOpen={setOpenDiagramModalOpen}
      />
      <BrowseTemplatesModal
        open={isBrowseTemplatesModalOpen}
        setOpen={setBrowseTemplatesModalOpen}
      />
    </GlobalModalsContext.Provider>
  );
};

export default GlobalModalsProvider;
